/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import CompendiumTabs from "./CompendiumTabs";

class PanelTargetManageList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: [], search: "", status: "all"
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.fillList('/api/target/list', 'list');
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/target/manage/new')}><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New Target</L></span></button>
        </>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    search = (e) => {
        this.setState({ search: e.target.value });
    }

    list = () => {
        const query = this.state.search.trim().toLowerCase();
        const list = (this.state.list ?? []).filter(row =>
            (this.state.status === 'all' || (this.state.status === 'disabled' ? !!row.isDisabled : !row.isDisabled)) &&
            (!query || ['name', 'code', 'units', 'refRange'].some(field => String(row[field] ?? '').toLowerCase().includes(query)))
        );

        return list;
    }

    onSort = () => {
    }

    render() {
        const columns = [
            { name: 'edit', title: '', valueFunc: (row) => <Link to={`/target/manage/${row.id}`} title="Edit" aria-label={`Edit ${row.name || row.code}`}><Icon icon="faPencil" /></Link>, width: '25px' },
            { name: 'code', title: 'Code', valueFunc: (row) => <Link to={`/target/manage/${row.id}`} title="Edit">{row.code}</Link>, width: '150px' },
            { name: 'name', title: 'Name', valueFunc: (row) => <Link to={`/target/manage/${row.id}`} title="Edit">{row.name}</Link> },
            { name: 'active', title: 'Status', valueFunc: (row) => <span className={'badge ' + (row.isDisabled ? 'bg-secondary' : 'bg-success')}><L>{row.isDisabled ? 'Disabled' : 'Active'}</L></span> }
        ];

        return <div className="container-fluid vh-expand u-page">
            <CompendiumTabs />
            <header className="u-header">
                <h1 role="heading" aria-level="1"><L>Manage Targets</L></h1>
                <div className="u-eyebrow"><Link to="/lab/manager"><L>Lab Management</L></Link></div>
                <p className="u-intro"><L>Manage the targets included in your panels.</L></p>
            </header>
            <div className="card border-0 shadow-sm mb-3">
                <div className="card-body d-flex flex-wrap align-items-center gap-3">
                    <div className="input-group flex-grow-1" style={{ flexBasis: '260px' }}>
                        <span className="input-group-text"><Icon icon="faSearch" /></span>
                        <input type="search" className="form-control" aria-label="Search targets"
                            placeholder="Search targets by name or code..." value={this.state.search} onChange={this.search} />
                        {this.state.search && <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({ search: '' })}><L>Clear</L></button>}
                    </div>
                    <select className="form-select w-auto" aria-label="Filter by status" value={this.state.status} onChange={e => this.setState({ status: e.target.value })}>
                        <option value="all">All statuses</option><option value="active">Active</option><option value="disabled">Disabled</option>
                    </select>
                    <span className="text-body-secondary small" role="status">{this.list().length} / {(this.state.list ?? []).length} <L>targets</L></span>
                </div>
            </div>
            {!this.state.loading && this.list().length === 0 && <div className="alert alert-light border" role="status"><L>No targets found. Try a different search or status.</L></div>}
            <DataTable columns={columns} data={this.list()} totalCount={this.state.totalCount} headClassName="--bg-primary" loading={this.state.loading} onSort={this.onSort} showCheckboxes={this.state.showFilters} defaultSort="name" defaultSortDesc />

        </div>;
    }
}

export default withParamsAndNavigate(PanelTargetManageList);